<template>
  <i class="i" @click="handleClick" ref="checkpoint">
    <div
      v-if="isCurrentFlagActive"
      :class="{ 'banner-text': !isFinish, 'banner-finish': isFinish }"
    >
      <slot name="banner" />
      <slot name="text" />
      <CloseIcon class="close-btn" :color="this.color" />
    </div>

    <Flag :isActive="changeColor" />

    <i class="content">
      <slot></slot>
    </i>

    <FlagWrap :isActive="changeColor" class="chechpoint" />
  </i>
</template>

<script>
import Flag from "./Flag.vue";
import FlagWrap from "./FlagWrap.vue";
import CloseIcon from "./CloseIcon.vue";

export default {
  props: {
    index: Number,
    checkpointPosition: Number,
    oldPosition: Number,
    currentPosition: Number,
    position: Number,
    flagIndex: Number,
    visibleFlag: Number,
    toggleFlag: Function,
    isFinish: Boolean,
    color: String,
  },
  components: {
    FlagWrap,
    Flag,
    CloseIcon,
  },

  data() {
    return {
      hasShownBanner: false,
      isFlagClicked: false,
      checkpoint: null,
      changeColor: false,
      positions: [1, 0, 1],
    };
  },
  computed: {
    isCurrentFlagActive() {
      // Сравниваем активный флаг с текущим индексом флага
      return this.visibleFlag === this.index;
    },
    isActive() {
      return this.currentPosition >= this.position;
    },
  },
  watch: {
    isActive(newValue) {
      this.changeColor = newValue;
    },

    currentPosition(newValue) {
      if (newValue === this.position) {
        this.animate({
          duration: 3000,
          timing: this.calcTiming(this.linear),
          draw: this.draw,
        });
      }
    },
  },
  methods: {
    handleClick() {
      this.toggleFlag(this.index);

      this.isFlagClicked = this.isCurrentFlagActive;
    },

    calcTiming(timing) {
      return (timeFraction) => 1 - timing(1 - timeFraction);
    },

    linear(timeFraction) {
      return timeFraction;
    },

    draw(progress) {
      const array = this.positions;
      let prog = Math.round(array.length * progress);

      this.checkpoint.style.transform = `scale(${array[prog]})`;

      if (progress > 0.5) {
        this.changeColor = true;
        this.handleClick();
      }
    },

    animate({ duration, timing, draw }) {
      let start = performance.now();

      requestAnimationFrame(function animate(time) {
        let timeFraction = (time - start) / duration;
        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        let progress = timing(timeFraction);

        draw(progress); // отрисовать её

        if (timeFraction < 1) {
          requestAnimationFrame(animate);
        }
      });
    },
  },
  mounted() {
    this.checkpoint = this.$refs.checkpoint;

    if (this.isActive) {
      this.changeColor = true;
    }
  },
};
</script>

<style scoped>
.banner-text {
  position: absolute;
  z-index: 22;
  bottom: 0;
  left: 0;
  margin-left: -100px;
  margin-bottom: 120px;
  border-radius: 20px;
  padding: 15px 18px;
  width: 300px;
  transition: all 1s linear;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background: #f6fafd;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  color: #000;
  animation: fadeInMove 0.5s ease forwards, wobble 0.3s ease-in-out 0.5s 1;
}

@media (max-width: 600px) {
  .banner-text {
    width: 300px;
    margin-left: -90px;
  }
}

.banner-finish {
  display: flex;
  justify-content: center;
  position: absolute;
  z-index: 22;
  bottom: 0;
  left: 0;
  margin-left: -110px;
  margin-bottom: 120px;
  border-radius: 20px;
  transition: all 1s linear;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  color: #000;
  animation: fadeInMove 0.5s ease forwards, wobble 0.3s ease-in-out 0.5s 1;
}

@keyframes fadeInMove {
  0% {
    opacity: 0;
    transform: translateY(10px); /* Немного сдвинуто вниз */
  }
  100% {
    opacity: 1;
    transform: translateY(0); /* Плавно возвращается в нормальное положение */
  }
}

@keyframes wobble {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(1deg);
  }
  50% {
    transform: rotate(-2deg);
  }
  75% {
    transform: rotate(1deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.i {
  display: block;
  height: 112px;
  width: 61.2px;
  cursor: pointer;
  transition: all 1s linear;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 7px;
  margin-top: 14px;
}

.chechpoint {
  position: absolute;
  bottom: -20px;
  left: 12px;
}

.close-btn {
  position: absolute;
  top: 0;
  width: 25px;
  margin-top: 10px;
  margin-right: 5px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/CheckPoint.vue